export const SELECTORS = {
    container: '.appointment-cancel__container',
    body: '.appointment-cancel__body',
    card: '.appointment-cancel__body .card',
    icon: '.appointment-cancel__body .icon',
    checkIconWrapper: '.appointment-cancel__container .icon .custom-check-icon-wrapper',
    informationCard: '.appointment-cancel__body .information .card',
    staffInfo: '.appointment-cancel__container .time-staff__info .staff__info',
    timeInfo: '.appointment-cancel__container .time-staff__info .time__info',
    dateInfo: '.appointment-cancel__container .date__info',
    actionDiv: '.appointment-cancel__container .card .action',
    appointmentButtons: '.appointment-cancel__container .appointment-confirm-single',
    title: '.appointment-cancel__body .title',
    confirmBtn: '#confirm-appointment-btn',
    cancelLink: '#cancel-appointment-link',
    logo: '.appointment-cancel__container .appointment__logo',
    pendingBanner: '.appointment-cancel__container .pending-approval-banner',
    cancelledBanner: '.appointment-cancel__container .cancelled-appointment-banner'
};

export const MESSAGES = {
    errors: {
        eventIdNotFound: "Error: Event ID not found",
        locationUndefined: "Error! Location is undefined.",
        cancelFailed: "Error cancelling appointment. Please try again.",
        copyFailed: "Error! Cannot copy to clipboard.",
        invalidResponse: "Invalid response from server"
    },
    success: {
        addressCopied: "Address copied to clipboard",
        cancelAppointment: "Appointment cancelled!"
    },
    ui: {
        processing: "Processing...",
        cancel: "Cancel",
        cancelled: "Cancelled",
        appointmentCancelled: "Your appointment has been cancelled",
        bookNewAppointment: "Book New Appointment"
    },
    banner: {
        cancelled: "Appointment cancelled",
        cancelledDescription: "Your appointment has been successfully cancelled. You can book a new appointment anytime."
    }
};

export const BUTTON_CONFIG = {
    bookNew: {
        id: 'book-new-appointment-btn',
        className: 'button--no-style book-new-button book-new-button-large',
        text: 'Book New Appointment',
        loadingText: 'Processing...',
        type: 'button'
    }
};

export const APPOINTMENT_STATUS = {
    REQUEST: 'request',
    CONFIRMED: 'confirmed',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled'
};

export const PARTICIPANT_TYPES = {
    LEAD: 'App\\Models\\Lead',
    STAFF: 'App\\Models\\Staff'
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};

export const COLORS = {
    error: '#e74c3c',
    success: '#11b654',
    cancel: '#e74c3c'
};

export const TIMEOUTS = {
    defaultToast: 3000,
    buttonReset: 2000
};
